window.VoucherGeneration = (function($) {
    window.dataLayer = window.dataLayer || [];
    const self = {
        elements: {
            ids: {
                modalLoadingSpinner: '#modal-loading',
                modalContent: 'section#modal-content',
                modalHeader: '#modal-header',
                modalError: 'section#modal-error',
                modalVoucher: '#vouchermodal-code',
                modalVoucherExpiry: '#vouchermodal-codeexpiry',
                stickyFooterVoucherCode: '#sticky-footer-voucher-code',
                voucherExpiredNotification: '#voucher-expired-message',
                voucherExpiredStickyFooter: '#VoucherExpired',
                pregeneratedVoucherError: '#pregenerated-voucher-error',
                voucherErrorStickyFooter: '#VoucherError'
            },
            attributes: {
                copyContent: 'data-copycontent',
                destination: 'data-destination'
            },
            selectors: {
                genVoucherBlock: '.cta-block-voucher-generate-code',
                genVoucherFooter: '#VoucherAvailable'
            },
            buttons: {
                generateVoucherButton: '#voucher-generate-code',
                stickyFooterGenerateVoucherButton: '#sticky-footer-generate-code',
                modalCopyAndGoButton: '#voucher-modal-copy-and-go',
                stickyFooterCopyAndGoButton: '#sticky-footer-copy-and-go',
                copyAndGoButton: '#voucher-copy-and-go',
                modalCloseIconButton: '#close-modal-icon',
                modalCloseButton: '#close-error-modal-button'
            },
            urls: {
                generateVoucherUrl: '/api/sitecore/{PartnerName}Voucher/AllocateVoucher'
            },
            voucherStateEnum: {
                voucherGenerated: 2
            }
        },
        state: {
            partnerName: '',
            isExperienceEditor: false
        },
        func: {
            init: function () {
                self.func.bindings();
                $(self.elements.ids.modalContent).hide();
                $(self.elements.ids.modalError).hide();
                self.state.partnerName = $('#page-data').data('partner-name');
                self.state.isExperienceEditor = $('#isExperienceEditor').val() === 'true';
                const voucherCode = $.trim($(self.elements.ids.stickyFooterVoucherCode).text());
                $(self.elements.buttons.stickyFooterCopyAndGoButton).attr(self.elements.attributes.copyContent, voucherCode);
            },
            bindings: function () {
                if (!self.state.isExperienceEditor) {
                    $(self.elements.selectors.genVoucherBlock).on('click', 'button', self.func.bodyOpenVoucherModal);
                    $(self.elements.selectors.genVoucherFooter).on('click', 'button:not(\'.vds-fixed-notification__close\')', self.func.stickyOpenVoucherModal);
                    $(self.elements.buttons.modalCopyAndGoButton).on('click', self.func.modalCopyVoucherClick);
                    $(self.elements.buttons.stickyFooterCopyAndGoButton).on('click', self.func.stickyFooterVoucherClick);
                    $(self.elements.buttons.copyAndGoButton).on('click', self.func.copyVoucherClick);
                    $(self.elements.buttons.modalCloseIconButton).on('click', self.func.setIsVisibleToFalse);
                    $(self.elements.buttons.modalCloseButton).on('click', self.func.setIsVisibleToFalse);
                }
            },
            bodyOpenVoucherModal: function (event) {
                if (event) {
                    event.preventDefault();
                }
                window.openModal('vouchermodal-generatecode');
                self.func.generateVoucher({
                    event: 'generateCode',
                    codeType: self.state.partnerName.toLowerCase(),
                    codeAction: 'bodyGenerateCode'
                });
            },
            stickyOpenVoucherModal: function (event) {
                if (event) {
                    event.preventDefault();
                }
                window.openModal('vouchermodal-generatecode');
                self.func.generateVoucher({
                    event: 'generateCode',
                    codeType: self.state.partnerName.toLowerCase(),
                    codeAction: 'stickyGenerateCode'
                });
            },
            generateVoucher: function (gtmVoucherSuccess) {
                const url = self.elements.urls.generateVoucherUrl.replace('{PartnerName}', self.state.partnerName);
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: {},
                    success: function (voucher) {
                        const code = voucher.voucherCode;
                        const expiry = voucher.expiryDate;
                        const formattedExpiryDate = expiry.substring(8, 10) + "/" + expiry.substring(5, 7) + "/" + expiry.substring(2, 4);
                        self.func.displayVoucher(code, formattedExpiryDate);
                        $(self.elements.buttons.modalCopyAndGoButton).attr('data-copycontent', code);
                        window.dataLayer.push(gtmVoucherSuccess);
                    },
                    error: function (error) {
                        self.func.handleVoucherFailure(error);
                    }
                });
            },
            displayVoucher: function (code, expiry) {
                self.func.setIsVisibleToFalse();
                $(self.elements.ids.modalVoucher).text(code);
                $(self.elements.ids.modalVoucherExpiry).text(expiry);
                $(self.elements.ids.modalLoadingSpinner).hide();
                $(self.elements.ids.modalContent).show();
            },
            displayError: function () {
                self.func.setIsVisibleToTrue();
                $(self.elements.ids.modalLoadingSpinner).hide();
                $(self.elements.ids.modalContent).hide();
                $(self.elements.ids.modalError).show();
            },
            handleVoucherFailure: function (error) {
                self.func.displayError();
                const errorCode = self.func.getErrorMessage(error.status);
                const gtmVoucherError = {
                    event: 'generateCode',
                    codeType: self.state.partnerName.toLowerCase(),
                    codeError: errorCode
                };
                window.dataLayer.push(gtmVoucherError);
            },
            modalCopyVoucherClick: function (event) {
                const gtmCopyVoucher = {
                    event: 'generateCode',
                    codeType: self.state.partnerName.toLowerCase(),
                    codeAction: 'modalCopyAndGo'
                };
                window.dataLayer.push(gtmCopyVoucher);
                self.func.copyAndGoButtonClick(event);
            },
            stickyFooterVoucherClick: function (event) {
                const gtmCopyVoucher = {
                    event: 'pregeneratedCode',
                    codeType: self.state.partnerName.toLowerCase(),
                    codeAction: 'stickyCopyAndGo'
                };
                window.dataLayer.push(gtmCopyVoucher);
                self.func.copyAndGoButtonClick(event);
            },
            copyAndGoButtonClick: function (event) {
                if ($(event.target).attr(self.elements.attributes.copyContent)) {
                    self.func.copyContent(event);
                }
                if ($(event.target).attr(self.elements.attributes.destination)) {
                    self.func.goToDestination(event);
                }
            },
            copyVoucherClick: function (event) {
                const gtmCopyVoucher = { event: 'pregeneratedCode', codeType: self.state.partnerName.toLowerCase(), codeAction: 'bodyCopyAndGo' };
                window.dataLayer.push(gtmCopyVoucher);
                self.func.copyAndGoButtonClick(event);
            },
            copyContent: function (event) {
                window.copyContent(event.target);
            },
            goToDestination: function (event) {
                window.location = $(event.target).attr(self.elements.attributes.destination);
            },
            setIsVisibleToTrue: function () {
                $(self.elements.ids.modalError).attr('isVisible', true);
            },
            setIsVisibleToFalse: function () {
                $(self.elements.ids.modalError).attr('isVisible', false);
            },
            getErrorMessage: function(status) {
                const httpUnprocessableEntity = 422;
                if (status === httpUnprocessableEntity) {
                    return 'noVouchersAvailable';
                }
                return 'unknownVoucherFailure';
            }
        },
        gtm: {
            checkForExpiredVoucher: function () {
                const voucherExpiredNotificationExists = $(self.elements.ids.voucherExpiredNotification).length;
                const voucherExpiredStickyFooterExists = $(self.elements.ids.voucherExpiredStickyFooter).length;
                if (voucherExpiredNotificationExists || voucherExpiredStickyFooterExists) {
                    const partnerName = $('#page-data').data('partner-name');
                    const gtmVoucherExpired = {
                        event: 'pregeneratedCode',
                        codeType: partnerName.toLowerCase(),
                        codeError: 'expired'
                    };
                    window.dataLayer.push(gtmVoucherExpired);
                }
            },
            checkForErrorVoucher: function () {
                const pregeneratedVoucherError = $(self.elements.ids.pregeneratedVoucherError);
                const pregeneratedVoucherErrorExists = pregeneratedVoucherError.length;
                const voucherErrorStickyFooterExists = $(self.elements.ids.voucherErrorStickyFooter).length;
                if (pregeneratedVoucherErrorExists || voucherErrorStickyFooterExists) {
                    const partnerName = $('#page-data').data('partner-name');
                    const codeError = pregeneratedVoucherError.val() || 'unknownVoucherFailure';
                    const gtmVoucherError = {
                        event: 'pregeneratedCode',
                        codeType: partnerName.toLowerCase(),
                        codeError: codeError
                    };
                    window.dataLayer.push(gtmVoucherError);
                }
            }
        }
    };

    return {
        init: self.func.init,
        gtm: self.gtm
    };

})(window.jQuery);

$('document').ready(function () {

    const generateVoucherButtonExists = $('#voucher-generate-code').length;
    const pregeneratedCopyVoucherButtonExists = $('#voucher-copy-and-go').length;
    const stickyFooterCopyVoucherButtonExists = $('#sticky-footer-copy-and-go').length;

    if (generateVoucherButtonExists || pregeneratedCopyVoucherButtonExists || stickyFooterCopyVoucherButtonExists) {
        window.VoucherGeneration.init();
    }

    window.VoucherGeneration.gtm.checkForExpiredVoucher();
    window.VoucherGeneration.gtm.checkForErrorVoucher();

});
